import React from "react";

import useWindowDimensions from "../../functions/windows";
import { ICoupon } from "../../interfaces/coupon";
import { IUser } from "../../interfaces/user";
import { deleteCoupon, getAllCoupons } from "../../services/coupon.service";
import { getAllUser } from "../../services/user.service";
import { useError } from "../../store/ErrorModal";

export default function useCouponSettingPage() {
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [coupon, setCoupon] = React.useState<ICoupon>();
  const [data, setData] = React.useState<ICoupon[]>([]);
  const [isOpenDelete, setIsOpenDelete] = React.useState<boolean>(false);
  const [deleteId, setDeleteId] = React.useState<string>();
  const [allUser, setAllUser] = React.useState<IUser[]>();
  const { onError } = useError();
  const { width } = useWindowDimensions();

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      await deleteCoupon(deleteId);
      setCoupon(undefined);
      setIsOpenDelete(false);
      fetchData();
    } catch (error) {
      onError(error as any);
    }
  };

  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getAllCoupons();
      const user = await getAllUser();
      setAllUser(user.data);
      setData(res.data);
    } catch (error) {
      onError(error as any);
    }
    setIsLoading(false);
  }, [onError]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  React.useEffect(() => {
    if (deleteId) setIsOpenDelete(true);
  }, [deleteId]);

  return {
    isOpen,
    setIsOpen,
    fetchData,
    width,
    data,
    setCoupon,
    coupon,
    allUser,
    setIsOpenDelete,
    setDeleteId,
    isLoading,
    isOpenDelete,
    handleDelete,
  };
}
